import React,{ Component } from 'react'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import { getProductosAdmin } from '../actions'
import AdminMenu from '../components/admin_menu'

class AdminProductos extends Component{
	
	constructor(props) {
    	super(props);
    	this.state = {
        	loading : false,
          estados:[
          "NULO",
          "ACTIVO"
          ]
    	}
      this.verProducto=this.verProducto.bind(this)
    }

  componentDidMount(){
    if(!this.props.usuario.user){
      this.props.history.push("/login")
    }
    this.props.getProductosAdmin(1)
  }

  componentDidUpdate(prevProps, prevState){

  }

  verProducto(id){
     this.props.history.push("/admin/producto/"+id)
  }

  limpiaCarro(){

  }



	render() {  
    const  productos = this.props.productos.lista.map((producto,i)=>{
      return <tr key={i}>
          <td>{producto.rubro.nombre}</td>
          <td>{producto.categoria.nombre}</td>
          <td>{producto.nombre}</td>
          <td>{this.state.estados[producto.estado]}</td>
          <td>
          <button type="button" className="btn btn-info" onClick={e => this.verProducto(producto.id)}>
              <i className="fas fa-pencil-alt" />
            </button>
          </td>
        </tr>;
    })

    return (
      <div className="container">
      <section className="row mb-5 sombraHead mt-3 clearfix" >
        <div className="col-md-3 mb-3">
          <AdminMenu />
        </div>

        <div className="col-md-9 p-3">
          <div>
            <h1 className="display-4">Productos</h1>
          </div>

          <table className="table">
            <thead>
              <tr>
                <th scope="col">FECHA</th>
                <th scope="col">DETALLE</th>
                <th scope="col">MONTO</th>
                <th scope="col">ESTADO</th>
                <th><button type="button" className="btn btn-info" onClick={(e) => this.props.history.push("/admin/producto_form/")}><i className="fas fa-plus"></i></button></th>
              </tr>
            </thead>
            <tbody>
              { productos }
            </tbody>
          </table>
          
        </div>

      </section>
      </div>
    )
  }
}

const mapStateToProps = state => {
	return {
    	productos: state.productos,
      usuario: state.usuario
  	}
}

const mapDispatchToProps = dispatch => {
  return {
    getProductosAdmin: (pag) => {
      dispatch(getProductosAdmin(pag))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AdminProductos)




// WEBPACK FOOTER //
// ./src/containers/admin_prods.js